import i18n from '@/i18n';

const configModalTemporarily = {
    title: 'テンプレート',
    model: false,
    scrollable: true,
    hideFooter: false,
    validate: true,
    centered: true,
    size: 'lg'
};

const initForm = () => {
    return {
        name: ''
    };
};

const initConfig = () => {
    return {
        configFieldNameTemp: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.temporarily.nameTemp'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['required', 'max255']
        }
    };
};

export { configModalTemporarily, initForm, initConfig };
